module.exports = __webpack_public_path__ + "img/menuItem_bg.c02f84ad.png";